import { render } from "./PaymentFailure.vue?vue&type=template&id=01d727f4&scoped=true"
import script from "./PaymentFailure.vue?vue&type=script&lang=js"
export * from "./PaymentFailure.vue?vue&type=script&lang=js"

import "./PaymentFailure.vue?vue&type=style&index=0&id=01d727f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d727f4"]])

export default __exports__